"use client";

import { StateCreator } from "zustand";
import { PredefinedAction, Reminder } from "@clients/velys-infrastructure/api";

export const initialNewPredefindActionReminder: Reminder = {
  execution_date: "",
  days_before_due_to_remind: 0,
  message: "",
  always_send: false,
};

export const initialNewPredefindAction: PredefinedAction = {
  title: "",
  description: "",
  delta_days_from_surgery: "0",
  reminders: [initialNewPredefindActionReminder],
  required: true,
};

export type PredefinedActionItemsState = {
  isCreate: boolean;
  isDelete: boolean;
  predefinedActionItem: PredefinedAction | null;

  // actions
  setIsCreate: (isCreate: boolean) => void;
  setIsDelete: (isCreate: boolean) => void;
  setPredefinedActionItem: (newItem: PredefinedAction | null) => void;
};

export const createPredefinedActionItemsSlice: StateCreator<
  PredefinedActionItemsState
> = (set) => ({
  isCreate: false,
  isDelete: false,
  predefinedActionItem: null,

  // actions
  setIsCreate: (isCreate) => set({ isCreate }),
  setIsDelete: (isDelete) => set({ isDelete }),
  setPredefinedActionItem: (newItem) => set({ predefinedActionItem: newItem }),
});
